module.exports = {"440802001":"中华街道","440802002":"寸金街道","440802003":"民主街道","440802004":"中山街道","440802005":"沙湾街道","440802006":"调顺街道","440802007":"南桥街道","440802008":"北桥街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440802.json
// module id = 1823
// module chunks = 0